
<div >
  


  <div class="row" style="margin-top: 20px;">
    <div class="col-lg-1">
        <p class="title-descriptor">Filtrar Por:</p>
    </div>
    <div class="col-lg-2">
        <mat-form-field>
            
            <mat-label>Región</mat-label>
            <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                <mat-option [value]="0">Seleccione Región</mat-option>
                <mat-option [value]="regiones.idRegion" *ngFor="let regiones of infoSelectJardin.regiones">{{regiones.nombre}}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="hasError('region', 'required')">Región es requerido</mat-error>
            <mat-error *ngIf="hasError('region', 'min')">Región es requerido</mat-error> -->
        </mat-form-field>  
    </div>
    <div class="col-lg-2">
        <mat-form-field>
            <mat-label>Comuna</mat-label>
            <mat-select id="comuna" class="selectMedio" name="comuna" (selectionChange)="seleccionarComuna($event.value)">
                <mat-option [value]="0">Seleccione Comuna</mat-option>
                <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="hasError('comuna', 'required')">Comuna es requerido</mat-error>
            <mat-error *ngIf="hasError('comuna', 'min')">Comuna es requerido</mat-error> -->
        </mat-form-field>   
    </div>
    <div class="col-lg-2">
        <mat-form-field>
            <mat-label>Programa</mat-label>
            <mat-select  placeholder="" floatlLabel="never" id="programa" class="selectMedio" name="programa" (selectionChange)="seleccionarPrograma($event.value)">
                <mat-option value="0">Seleccione Programa</mat-option>
                <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of infoSelectJardin.programas">{{programas.descripcionLarga}}</mat-option>
            </mat-select>
            <!-- <mat-error *ngIf="hasError('programa', 'required')">Programa es requerido</mat-error> -->
        </mat-form-field>
    </div>
    <div class="col-lg-5 d-flex justify-content-end" >
      <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
              <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
    </div>
  </div>
  <div class="row">
    <div class="d-flex justify-content-end">
      <a class="btn" [attr.href]="apiEndpoint + 'adminUsuarioInformes/2'" target=”_blank”  style="width: 40px;border-radius: 50%;background-color: #597CEE;color: #fff;"> <i class="fas fa-download"></i> </a>
    </div>
  </div>


  <div>
    <table class="tables-info" mat-table [dataSource]="dataSourceOtrasCuentas" matSort>
  
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef > Región </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.region}} </td>
      </ng-container>

      <ng-container matColumnDef="estamento">
        <th mat-header-cell *matHeaderCellDef > Perfil/Estamento </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.estamento != null ? row.estamento : row.perfil}} </td>
      </ng-container>

      <ng-container matColumnDef="codigoJardin">
        <th mat-header-cell *matHeaderCellDef > Código JI </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.codigoJardin}} </td>
      </ng-container>

      <ng-container matColumnDef="nombreJardin">
        <th mat-header-cell *matHeaderCellDef > Nombre JI </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.nombreJardin}} </td>
      </ng-container>

      <ng-container matColumnDef="nombres">
        <th mat-header-cell *matHeaderCellDef > Nombres</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.nombres}} </td>
      </ng-container>

      <ng-container matColumnDef="apellidos">
        <th mat-header-cell *matHeaderCellDef > Apellidos</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.apellidos}} </td>
      </ng-container>

      <ng-container matColumnDef="correo">
        <th mat-header-cell *matHeaderCellDef > Correo</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.correo}} </td>
      </ng-container>

      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef > Usuario</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.usuario}} </td>
      </ng-container>

      <ng-container matColumnDef="password">
        <th mat-header-cell *matHeaderCellDef > Contraseña</th>
        <td mat-cell *matCellDef="let row" [ngClass]="{'closed':row.bloqueo}"> {{row.password}} </td>
      </ng-container>

      <ng-container matColumnDef="bloqueo">
        <th mat-header-cell *matHeaderCellDef > Bloqueado</th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox class="example-margin" [(ngModel)]="row.bloqueo" (change)="bloquear(row, 'us_persona')">
            <span class="material-icons closed" *ngIf="row.bloqueo">lock</span>
            <span class="material-icons open" *ngIf="!row.bloqueo">lock_open</span>                        
          </mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsOtrasCuentas"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsOtrasCuentas;">
      </tr>
    </table>

    <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[10, 50, 100]"
            [showFirstLastButtons]="true"
            (page)="getServerData($event)">
        </mat-paginator>
  </div>
</div>

<ngx-spinner></ngx-spinner>